<template>
  <div >
      <div style="height:50px;display:flex;background:#3D7878">
          <img style="height:54px;width:54px;margin-right:10px;color:#5cadff; "   src="img/logon.png"/>
          <div style="color:#fff;font-weight: 700;font-size: 20px;line-height:45px;margin-top:5px; ">信息管理系统</div>
      </div>
      <van-cell-group inset style="margin-top:2px; ">
          <div style="display:flex">
            <div style="margin-top:20rem;margin-left:5rem;margin-right:5rem">
              <i class="iconfont icon-kehu1" style="font-size:48px;color:#99ccff"></i>
            </div>
 
            <van-cell-group inset style="margin-left:20rem;width:300rem;">  
              <van-cell  title="用户账号"  :value="userNo" ></van-cell>
              <van-cell  title="用户名称"  :value="userNm" ></van-cell>
              <van-cell  title="部门名称"  :value="deptNm" ></van-cell>
              <van-cell  title="职位名称"  :value="jobNm" ></van-cell>
              <van-cell  title="账套名称"  :value="v_corpnm" ></van-cell>
            </van-cell-group>
          </div>
      </van-cell-group>
      <!-- 基本信息 -->
      <div style="border-left:5px solid #409eff;line-height:34rem;margin-top:10px;background:white ">
        <span style="padding-left:10px;font-weight:600;font-size:14rem;color:#303133">修改密码</span>
      </div>
      <van-cell-group inset style="margin-top:2px;">
         <van-field
            v-model="upPwd"
            type="password"
            clearable
            input-align="center"
            placeholder="请输入不少于4位数"
            style=" line-height:40px; "
            :rules="[{ required: true, message: '请填写新密码' }]"  >
            <div slot="label" class="notnull"  >
               <span  style="color:black">新密码</span> *
            </div>
          </van-field>
          <van-field
            v-model="upPwd2"
            type="password"
            clearable
            input-align="center"
            placeholder="请输入不少于4位数"
            style=" line-height:40px; "
            :rules="[{ required: true, message: '请填写确认密码' }]"  >
            <div slot="label" class="notnull"  >
               <span  style="color:black">确认密码</span> *
            </div>
          </van-field>
          <van-button @click="pwdCfm"  type="primary" round style="width:100%;padding:8rem;margin-top:10rem;margin-bottom:10rem">
            <i class= "iconfont icon-chenggong1" style="margin-right:5px;"></i>确认修改
          </van-button>
      </van-cell-group>
 
  </div>
</template>

<script>
 
export default {
  name: "chagne_pwd",
  data() {
    return {
      v_usernm:this.$cookies.get('v_usernm' ),
      v_username :this.$cookies.get('v_telno' ), //用户名称 
      v_corpid:this.$cookies.get('v_corpid' ) ,
      v_corpnm:'',
      empArr:[],
      userNo:'',
      userNm:'',
      deptNm:'',
      jobNm:'' ,
      NEWPWD:'',
      CFMPWD:'',
    };
  },
 
  methods: {
    //密码修改
    pwdCfm(){   
        let pwd_ =this.NEWPWD
        let cfmpwd_=this.CFMPWD
        if (!pwd_){
            this.$toast({type:'fail',message: '新密码不能为空'})
        }else if (!cfmpwd_){
            this.$toast({type:'fail',message: '确认密码不能为空'})
        }else{
            if(pwd_.length<4){
                this.$toast({type:'fail',message: '密码长度不能少于4位'})
            }else if(cfmpwd_.length<4){
                this.$toast({type:'fail',message: '确认密码长度不能少于4位'})
            }else if(pwd_!==cfmpwd_){
                this.$toast({type:'fail',message: '新密码和确认密码不匹配,请核查'})
            }else{
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updatePassword',
                    data: {p_value:this.v_username, p_table:'sys_user',p_value2:pwd_},
                }).then(res=>{      
                    if(res.result ==='OK')  {          
                        this.$toast({type:'success',message: '已修改成功'}) 
                        this.NEWPWD=''
                        this.CFMPWD=''
                    }else{
                        this.$toast({type:'fail',message: res.result})
                    }        
                })     
            }         
        }
    },
 
 
  },
  mounted() {
    if (this.$cookies.get('v_telno' )){
        this.$axios({  //传入 p_frmid 参数是为了生成 表单 的编码
            method: 'post',
            url:  'xuper_auth/getBaseData',
            data: {p_key:'telno',p_value:this.v_username,  p_table:'V_SYS_USER' },
        }).then(res=>{ 
          if (res.code=='200'){
            this.userNm =res.result[0]['USERNM']
            this.userNo =this.v_username
            this.deptNm =res.result[0]['DEPTNM']
            this.jobNm =res.result[0]['JOBNM']
          }
        }) 
        this.$axios({  //传入 p_frmid 参数是为了生成 表单 的编码
            method: 'post',
            url:  'xuper_auth/getBaseData',
            data: {p_key:'idseq',p_value:this.v_corpid,  p_table:'V_SYS_db' },
        }).then(res=>{ 
          if (res.code=='200'){
            this.v_corpnm =res.result[0]['CORPNM']
 
          }
        })
    }else{
      this.$router.push({path:'/login'})
    }
 
  },
  computed: {
    upPwd:{
        get(){
            return this.NEWPWD
        },
        set(val){
            this.NEWPWD =val 
        }
    } ,
    upPwd2:{
        get(){
            return this.CFMPWD
        },
        set(val){
            this.CFMPWD =val 
        }
    } ,
  }
};
</script>
<style lang="scss" scoped>
  .notnull{
    color:red;
  }
  .mul-div{
      text-overflow:ellipsis; /*对超出容器的部分强制截取，高度不确定则换行*/
      overflow:hidden; /*显示省略符号来代表被修剪的文本。*/
      white-space:nowrap; //禁止换行,文本溢出显示省略号，要显示全内容在DIV上增加title属性
      line-height:20px; 
  }
</style>
 
